module.exports = __webpack_public_path__ + "img/laravel-logo.d1390764.png";